









export default {
  name: 'NotFound'
};
